









export default {
  name: 'NotFound'
};
